import { RouteConfig } from 'vue-router';

const PlatformsView = () => import('@/views/platforms.vue');
const PlatformsViewIndex = () => import('@/views/platforms/index.vue');

const TaxPayersView = () => import('@/views/platforms/tax-payers.vue');
const TaxPayersViewIndex = () =>
  import('@/views/platforms/tax-payers/index.vue');

const InfoView = () => import('@/views/platforms/info/index.vue');
const ReportsView = () => import('@/views/platforms/reports/index.vue');
const ReportReciepts = () =>
  import('@/views/platforms/reports/report-tax-receipts.vue');
const ReportTaxpayers = () =>
  import('@/views/platforms/reports/report-taxpayers.vue');
const ReportPartners = () =>
  import('@/views/platforms/reports/report-partners.vue');

export default {
  path: '/platforms',
  component: PlatformsView,
  meta: {
    name: 'page.platforms',
  },
  children: [
    {
      path: '',
      name: 'platforms-index',
      redirect: { name: 'platforms-taxpayers-index' },
      component: PlatformsViewIndex,
    },
    {
      path: 'taxpayers',
      component: TaxPayersView,
      meta: {
        name: 'section.taxPayers',
      },
      children: [
        {
          path: '',
          name: 'platforms-taxpayers-index',
          component: TaxPayersViewIndex,
        },
      ],
    },
    {
      path: 'info',
      component: InfoView,
      name: 'platforms-info-index',
      meta: {
        name: 'section.info',
      },
    },
    {
      path: 'reports',
      component: ReportsView,
      name: 'platforms-reports-index',
      meta: {
        name: 'section.reports',
      },
    },
    {
      path: 'report-taxpayers',
      component: ReportTaxpayers,
      name: 'platforms-report-taxpayers',
      meta: {
        name: 'section.reports',
      },
    },
    {
      path: 'report-receipts',
      component: ReportReciepts,
      name: 'platforms-report-tax-receipts',
      meta: {
        name: 'section.reports',
      },
    },
    {
      path: 'report-partners',
      component: ReportPartners,
      name: 'platforms-report-partners',
      meta: {
        name: 'section.reports',
      },
    },
  ],
} as RouteConfig;
